<div
  class="tw-bg-dt-surface-card tw-rounded-xl tw-p-6 tw-shadow-card-elevated tw-w-1/2 md:tw-w-full"
>
  <form #form class="tw-flex tw-w-full tw-flex-col tw-gap-6" id="preference">
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-6">
      <div>
        <app-dropdown-select
          [title]="'userLocation' | i18n"
          [label]="'userLocation' | i18n"
          [options]="userLocationOptions"
          [sort]="'date'"
          [selectedOption]="selectedLocation"
          [showGradientBorder]="false"
          (optionSelected)="onUserLocationSelected($event)"
        >
        </app-dropdown-select>
      </div>
      <div>
        <app-dropdown-select
          [title]="'selectCurrency' | i18n"
          [label]="'coreCurrency' | i18n"
          [options]="currencyOptions"
          [selectedOption]="this.currentPreference.coreCurrency"
          [showGradientBorder]="false"
          (optionSelected)="onBaseCurrencySelected($event)"
        >
        </app-dropdown-select>
      </div>
      <ng-container>
        <div>
          <app-dropdown-select
            [title]="'selectDateFormat' | i18n"
            [label]="'dateFormats' | i18n"
            [options]="this.dateFormatOptions"
            [isEnabled]="false"
            [showGradientBorder]="false"
            [selectedOption]="this.currentPreference.dateFormat"
            (optionSelected)="onDateFormatSelected($event)"
          >
          </app-dropdown-select>
        </div>
      </ng-container>
      <div>
        <app-dropdown-select
          [title]="'theme' | i18n"
          [label]="'theme' | i18n"
          [options]="Object.keys(themeOptions)"
          [selectedOption]="selectedTheme"
          [showGradientBorder]="false"
          (optionSelected)="onThemeSelected($event)"
        >
        </app-dropdown-select>
      </div>
    </div>
    <app-gloss-button
      class="tw-w-full"
      [options]="{
        text: 'save' | i18n,
        type: 'submit',
        class: 'primary',
        onClick: onSubmitForm.bind(this),
        isEnabled: !formState().isSaving,
      }"
    ></app-gloss-button>
  </form>
</div>
